module.exports = __webpack_public_path__ + "84121909a5456e69e376cc5de6cfceba.svg";